import * as MutationsType from "./mutationsType";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.SET_SUBSCRIPTION](state, payload) {
    state.subscription = payload;
  },
};
